var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"container",staticClass:"tooltip-style",class:_vm.background},[_c('span',{ref:"target",staticClass:"target"},[_vm._t("default")],2),_c('div',{ref:"content",staticClass:"content",class:{'is-open': _vm.isOpen},attrs:{"role":"tooltip"}},[_vm._t("content"),_c('div',{staticClass:"arrow",attrs:{"data-popper-arrow":""}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }